/* eslint-disable react/require-default-props */
import React from "react";

import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import { SidebarListProps } from "../../types";

interface Props {
  sidebarList: SidebarListProps[];
  open: boolean;
  mobile: boolean;
}

export default function SidebarList({ sidebarList, open, mobile }: Props) {
  return (
    <List component="nav" sx={{ py: mobile ? 1 : 2, px: 1 }}>
      <>
        {sidebarList.map((item) => {
          const content = (
            <ListItemButton
              disabled={item.disabled}
              sx={{
                py: mobile ? 1.2 : 2,
                px: 2,
                mx: 1,
                borderRadius: 2,
                backgroundColor: item.isSelected ? "#e3f2fd" : "transparent",
                color: item.isSelected ? "#1976d2" : "#888",
                "&:hover": {
                  backgroundColor: item.isSelected ? "#e3f2fd" : "#f5f7fa",
                },
                "&.Mui-disabled": {
                  opacity: 0.5,
                  color: "#b0b0b0",
                },
                transition: "all 0.2s ease-in-out",
                justifyContent: open ? "flex-start" : "center",
              }}
              href={item.link}
            >
              <ListItemIcon
                sx={{
                  minWidth: "auto",
                  mr: open ? 2 : 0,
                  color: "inherit",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  height: mobile ? 28 : 32,
                  width: mobile ? 28 : 32,
                  borderRadius: "50%",
                  fontSize: 0,
                  backgroundColor: item.isSelected ? "#e3f2fd" : "transparent",
                  boxShadow: item.isSelected
                    ? "0 2px 8px rgba(25, 118, 210, 0.10)"
                    : "none",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#f5f7fa",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 20,
                    color: item.isSelected ? "#1976d2" : "#888",
                    transition: "color 0.2s",
                  },
                }}
              >
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: mobile ? 13 : 15,
                    fontWeight: item.isSelected ? 700 : 500,
                    letterSpacing: 0.2,
                    color: item.isSelected ? "#1976d2" : "#23272E",
                  }}
                  primary={item.name}
                />
              )}
            </ListItemButton>
          );
          return (
            <Box key={item.name}>
              {open ? (
                content
              ) : (
                <Tooltip title={item.name} placement="right">
                  {content}
                </Tooltip>
              )}
              {item.subMenu &&
                item.subMenu.some(
                  (subMenu: SidebarListProps) => subMenu.isSelected,
                ) && (
                  <List sx={{ pl: 2 }}>
                    {item.subMenu.map((subItem: SidebarListProps) => {
                      const subContent = (
                        <ListItemButton
                          key={subItem.name}
                          sx={{
                            py: mobile ? 1 : 1.5,
                            px: 2,
                            mx: 1,
                            borderRadius: 2,
                            backgroundColor: subItem.isSelected
                              ? "#e3f2fd"
                              : "transparent",
                            color: subItem.isSelected ? "#1976d2" : "#888",
                            "&:hover": {
                              backgroundColor: subItem.isSelected
                                ? "#e3f2fd"
                                : "#f5f7fa",
                            },
                            transition: "all 0.2s ease-in-out",
                            justifyContent: open ? "flex-start" : "center",
                          }}
                          href={subItem.link}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: "auto",
                              mr: open ? 2 : 0,
                              color: "inherit",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                              height: mobile ? 24 : 28,
                              width: mobile ? 24 : 28,
                              borderRadius: "50%",
                              fontSize: 0,
                              backgroundColor: subItem.isSelected
                                ? "#e3f2fd"
                                : "transparent",
                              boxShadow: subItem.isSelected
                                ? "0 2px 8px rgba(25, 118, 210, 0.10)"
                                : "none",
                              transition: "all 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#f5f7fa",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: 18,
                                color: subItem.isSelected ? "#1976d2" : "#888",
                                transition: "color 0.2s",
                              },
                            }}
                          >
                            {subItem.icon}
                          </ListItemIcon>
                          {open && (
                            <ListItemText
                              primaryTypographyProps={{
                                fontSize: mobile ? 12 : 14,
                                fontWeight: subItem.isSelected ? 700 : 500,
                                letterSpacing: 0.2,
                                color: subItem.isSelected
                                  ? "#1976d2"
                                  : "#23272E",
                              }}
                              primary={subItem.name}
                            />
                          )}
                        </ListItemButton>
                      );
                      return open ? (
                        subContent
                      ) : (
                        <Tooltip
                          title={subItem.name}
                          placement="right"
                          key={subItem.name}
                        >
                          {subContent}
                        </Tooltip>
                      );
                    })}
                  </List>
                )}
            </Box>
          );
        })}
      </>
    </List>
  );
}
